module.exports = __webpack_public_path__ + "static/img/dhdy.56cdc93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/example/dhdy.png
// module id = DuNy
// module chunks = 1